// Collapse / expand the "Advanced" block in the IC options panel.
export function toggleAdvanced() {
  const panel = document.getElementById("ic_advanced");
  const btn = document.getElementById("ic_advanced_toggle");
  if (!panel) return;
  const open = panel.style.display !== "none";
  panel.style.display = open ? "none" : "block";
  if (btn) btn.classList.toggle("open", !open);
}

window.toggleAdvanced = toggleAdvanced;
export default toggleAdvanced;
